import React, {useState} from "react";

import {Button, Dropdown, Form, Input, Radio, RadioGroup} from "rsuite";

export function Accommodations({ data, errors, onChange, passengerNo, sharing, setSharing }) {

  return (
    <>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Accommodation Details</h2>
        </div>
        <div className="card-body p-3 ">
          <style>
            {`
                    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100% !important;
      }
    `}
          </style>
          {/*{passengerNo > 1  &&*/}
          {/*  <Dropdown*/}
          {/*  menuStyle={{overflowY: "scroll", width: "100%"}}*/}
          {/*  style={{padding: "0.5rem 0", width: "100%"}}*/}
          {/*  trigger={["click"]}*/}
          {/*  title={*/}
          {/*    // data?.beds*/}
          {/*    //   ? "If you are travelling as a couple : " + data?.beds*/}
          {/*    //   :*/}
          {/*    "Do you want one or two beds?"*/}
          {/*  }*/}
          {/*>*/}
          {/*  {["Two Beds", "One Bed"].map((ele) => (*/}
          {/*    <Dropdown.Item onClick={() => onChange("beds", ele)}>*/}
          {/*      {ele}*/}
          {/*    </Dropdown.Item>*/}
          {/*  ))}*/}
          {/*</Dropdown>*/}
          {/*}*/}
          {passengerNo < 2 && (
            <>
              <label  style={{
                fontSize: 14,
                marginBottom: 10,
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span>Are you sharing with another guest?</span>
                {errors?.sharing_accommodation && (
                  <span style={{ color: 'red', fontSize: 13 }}>
      {errors?.sharing_accommodation}
    </span>
                )}
              </label>

              <RadioGroup
                name="sharingOption"
                onChange={(value) => {
                  setSharing(value);

                  if (value == 0) {
                    // Clear the name if "No" selected
                    onChange("sharing_accommodation_with", "");
                  }

                  onChange("sharing_accommodation", value);
                }}
                defaultValue={data?.sharing_accommodation}
              >
                <Radio value={1}>Yes</Radio>
                <Radio value={0}>No</Radio>
              </RadioGroup>

              {(sharing == 1 || data?.sharing_accommodation == 1) && (
                <>
                <Input
                  required
                  placeholder="Please enter their name"
                  onChange={(e) =>
                    onChange("sharing_accommodation_with", e)
                  }
                />
                  {errors?.sharing_accommodation_with && (
                    <Form.ErrorMessage show={errors?.sharing_accommodation_with}>
                      {errors?.sharing_accommodation_with}
                    </Form.ErrorMessage>
                  )}
                  </>
              )}
            </>
          )}

          {/*<label style={{ fontSize: 14, marginBottom: 10 }}>*/}
          {/*  Do you smoke or require a smoking room?*/}
          {/*</label>*/}
          {/*<RadioGroup*/}
          {/*  name="smokingRoom"*/}
          {/*  onChange={(value) => onChange("require_smoking_room", value)}*/}
          {/*  defaultValue={*/}
          {/*    data?.require_smoking_room ? data?.require_smoking_room : 0*/}
          {/*  } // Set the default value to 'No' or 'Yes' based on your requirement*/}
          {/*>*/}
          {/*  <Radio value={1}>Yes</Radio>*/}
          {/*  <Radio value={0}>No</Radio>*/}
          {/*</RadioGroup>*/}
          {(passengerNo > 1 || sharing == 1 ) &&
            <>
              <label  style={{
                fontSize: 14,
                marginBottom: 10,
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span>Do you want one or two beds?</span>
                {errors?.beds && (
                  <span style={{ color: 'red', fontSize: 13 }}>
      {errors?.beds}
    </span>
                )}
              </label>
          <RadioGroup
            name="beds"
            onChange={(value) => onChange("beds", value)}
            defaultValue={data?.beds}
          >
            <Radio value="One Bed">One Bed</Radio>
            <Radio value="Two Beds">Two Beds</Radio>
          </RadioGroup>
          </>
        }
        </div>
      </div>
    </>
  );
}
